<template>
  <div id="getCouponList">
    <div class="table-container">
      <div class="table-filtrate">
        <ul>
          <li>
            <span class="label">输入关键字:</span>
            <el-input
              placeholder="请输入内容"
              v-model="filtrate.keyword"
              @keyup.enter.native="getList(1)"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getList(1)"
              ></el-button>
            </el-input>
          </li>
          <li>
            <span class="label">优惠券类型:</span>
            <el-select
              v-model="filtrate.couponType"
              placeholder="请选择优惠券类型"
              clearable
              @change="getList(1)"
            >
              <el-option label="按时间" value="按时间"> </el-option>
              <el-option label="按金额" value="按金额"> </el-option>
              <el-option label="单次免费" value="单次免费"> </el-option>
            </el-select>
          </li>
          <li>
            <span class="label">使用状态:</span>
            <el-select
              v-model="filtrate.useFlag"
              placeholder="请选择优惠券类型"
              clearable
              @change="getList(1)"
            >
              <el-option label="未使用" value="未使用"> </el-option>
              <el-option label="已使用" value="已使用"> </el-option>
              <el-option label="已锁定" value="已锁定"> </el-option>
              <el-option label="已过期" value="已过期"> </el-option>
              <el-option label="已退款" value="已退款"> </el-option>
            </el-select>
          </li>
          <li>
            <span class="label">领劵开始时间:</span>
            <el-date-picker
              v-model="filtrate.startTime"
              type="datetime"
              placeholder="选择开始时间"
              @change="getList(1)"
            >
            </el-date-picker>
          </li>
          <li>
            <span class="label">领劵开始结束:</span>
            <el-date-picker
              v-model="filtrate.endTime"
              type="datetime"
              placeholder="选择开始时间"
              @change="getList(1)"
            >
            </el-date-picker>
          </li>
          <li>
            <el-button class="resetBtn" size="medium" @click="reset"
              >重置</el-button
            >
          </li>
        </ul>
      </div>
      <el-table
        :data="table.tableData"
        style="width: 100%"
        v-loading="table.loading"
      >
        <el-table-column prop="couponName" label="优惠券名称" align="center">
        </el-table-column>
        <el-table-column prop="couponType" label="优惠券类型" align="center">
        </el-table-column>
        <el-table-column prop="plateNum" label="车牌号" align="center">
        </el-table-column>
        <el-table-column prop="useFlag" label="使用状态" align="center">
        </el-table-column>
        <el-table-column label="用户头像" align="center">
          <template slot-scope="scope">
            <el-image
              class="platformAvatar"
              v-if="scope.row.platformAvatarUrl"
              :src="scope.row.platformAvatarUrl"
              :preview-src-list="[scope.row.platformAvatarUrl]"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="platformUserName"
          label="用户昵称"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="bindPhone" label="用户手机号" align="center">
        </el-table-column>
        <el-table-column prop="issueTime" label="领券时间" align="center">
        </el-table-column>
        <el-table-column prop="expireTime" label="过期时间" align="center">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          layout="sizes, total, prev, pager, next, jumper"
          background
          :total="table.total"
          :page-size.sync="table.pageSize"
          :current-page.sync="table.page"
          @current-change="getList"
          @size-change="getList(1)"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      filtrate: {
        keyword: "",
        couponType: "",
        useFlag: "",
        startTime: "",
        endTime: "",
      },

      table: {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 10,
        loading: false,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    reset() {
      this.filtrate = {
        keyword: "",
        couponType: "",
        useFlag: "",
        startTime: "",
        endTime: "",
      };
      this.getList(1);
    },
    async getList(page = this.table.page) {
      this.table.page = page;
      try {
        this.table.loading = true;
        let res = await this.$http.post("/coupon/list/issued", {
          merchantId: this.$route.params.id,
          pageNum: page,
          pageSize: this.table.pageSize,
          couponType: this.filtrate.couponType
            ? this.filtrate.couponType
            : null,
          useFlag: this.filtrate.useFlag ? this.filtrate.useFlag : null,
          startTime: this.filtrate.startTime ? this.filtrate.startTime : null,
          endTime: this.filtrate.endTime ? this.filtrate.endTime : null,
          keyword: this.filtrate.keyword,
        });
        if (res.code === 0) {
          for (let item of res.data.list) {
            item.expireTime = this.$moment(item.expireTime).format(
              "yyyy-MM-DD HH:mm:ss"
            );
            item.issueTime = this.$moment(item.issueTime).format(
              "yyyy-MM-DD HH:mm:ss"
            );
          }
          this.table.tableData = res.data.list;
          this.table.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {
        this.$message.error(err);
      } finally {
        this.table.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#getCouponList {
  .table-container {
    .platformAvatar {
      width: 50px;
      height: 50px;
    }
  }
}
</style>
